import {keys} from 'ts-transformer-keys';
import {Message} from '~/shared/src/utilities/message';
import {DataObjectProperties} from '~/shared/src/utilities/dataStructure';


type RequiredKeys<T> = { [K in keyof T]-? : {} extends Pick<T, K> ? never : K }[keyof T];
type RequiredOf<T> = Pick<T, RequiredKeys<T>>;


export type MailAttachment = {
    id : number;
    key : string;
    name : string;

    queryColumnName?: string;
    dataObject? : DataObjectProperties;

    messages: {
        filename? : Message;
    };
};
export const mailAttachmentProps = keys<MailAttachment>();
export const requiredMailAttachmentProps = keys<RequiredOf<MailAttachment>>();
export const mailAttachmentMessages = keys<Required<MailAttachment>[ 'messages' ]>() as string[];
